import { env } from "src/env";

export function getPublicProfilePath(slug: string): string {
  return `/c/${slug}`;
}

export function getPublicProfileUrl(slug: string): string {
  return `${env.VITE_APP_WEB_ORIGIN}${getPublicProfilePath(slug)}`;
}

export function getPublicProfileDisplayPrefix(): string {
  return `${env.VITE_APP_WEB_ORIGIN.replace(/^https?:\/\//, "")}/c/`;
}
